import * as moment from "moment";

export class DateValidator {
    dateFormat = 'MM/DD/YYYY HH:mm';
    error = true;

    validate(input) {
        if (moment(input, this.dateFormat, true).isValid()) {
            this.error = false;
        }
        return this.error;
    }
}

export class DateWithOutTimeValidator {
    dateFormat = 'MM/DD/YYYY';
    error = true;

    validate(input) {
        
        if (moment(input, this.dateFormat, true).isValid()) {
            this.error = false;
        }
        return this.error;
    }

}

//SB-3361
export class TimeValidator {
    timeFormat = 'HH:mm';
    error = true;

    validate(input) {
        if (moment(input, this.timeFormat, true).isValid()) {
            this.error = false;
        }
        return this.error;
    }

}